export function batchStatusToColorCode(status: string) {
    switch (status) {
        case 'completed':
            return '#70ca63';
        case 'active':
            return '#f6bb42';
        case 'open':
            return '#777777';
        case 'deleted':
            return '#999999';
        default:
            return '#3bafda';
    }
}
